import React from 'react'
import { CSSTransition } from '../TransitionGroup'

type CSSTransitionProps = Pick<
  React.ComponentProps<typeof CSSTransition<HTMLDivElement>>,
  'onExited'
>

interface ModalTransitionProps extends CSSTransitionProps {
  show: boolean
  ref?: React.RefObject<HTMLDivElement>
}

export const ModalTransition: React.FCC<ModalTransitionProps> = ({
  show: showModal,
  ref,
  ...props
}) => (
  <CSSTransition
    timeout={300}
    mountOnEnter
    unmountOnExit
    in={showModal}
    classNames="modal"
    nodeRef={ref}
    {...props}
  />
)
